module.exports = ".delete-team {\n  position: absolute;\n  right: 30%;\n  top: 5%; }\n\n.lgn-input {\n  border: none; }\n\n.work-area-names {\n  padding-left: 10px; }\n\n.work-area-names .mrgn-8p {\n    margin-bottom: 15px; }\n\n.add-wrkarea {\n  margin-top: -37px;\n  margin-left: 59%;\n  position: absolute; }\n\n.nw-usr {\n  border: none;\n  padding: 20px; }\n\n.form-add-usr {\n  padding-bottom: 30px; }\n\n.form-add-usr label {\n    color: #333D47;\n    padding-top: 15px;\n    margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/team-details/team-details.component.scss
// module id = ./src/app/team-details/team-details.component.scss
// module chunks = main